(ns ncr.search.toolbar
  (:require
   [cljs.core.async :refer-macros [go] :refer [<!]]
   [clojure.core.match :refer [match]]
   [clojure.string :as str]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.me :as me]
   [ncr.widgets.core :as w]
   [ncr.widgets.fragment :as wf]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.zip :as zip]
   [ncr.etc.profile-pspec :as pspec]
   [ncr.manage.preferences :as preferences]
   [ncr.fragment.common :as fragment-common]
   [ncr.fragment.folder :as fragment-folder]
   [ncr.fragment.share-send :as share-send]
   [ncr.fragment.label :as fragment-label]
   [ncr.fragment.access :as fragment-access]
   [ncr.fragment-types.attachments :as fragment.attachments]
   [ncr.fragment.props.money :as props.money]
   [ncr.search.selection :as sel]
   [ncr.widgets.datev]
   [ncr.widgets.zip :as wz]
   [ncr.nsql :as nsql]))

(defn- summarize-hints [trash-id fragments]
  (let
    [flags
     (for [f fragments]
       (-> f
         (select-keys [:promotedHint :writableHint :ownerWritableHint])
         (assoc
           :revoked (boolean (:revoked f))
           :in-trash (= (:folder f) trash-id))))]
    {:any (apply merge-with u/or* {} flags)
     :all (apply merge-with u/and* {} flags)}))

(defn c-toolbar [props {:keys [fragments fragments-by-id query]}]
  (let
    [selected (sel/use-selected)
     selected-fragments (vals (select-keys fragments-by-id selected))
     selected-count (count selected)
     has-selected? (> selected-count 0)

     me (uix/context me/*context*)
     trash-id (get (me/trash-folder me) :id)
     {:keys [any all]} (summarize-hints trash-id selected-fragments)

     handler
     (fn [action-fn]
       (fn [_]
         (go
           (u/when-ok [_ (<! (action-fn me selected-fragments))]
             (ps/pub! [:search/execute false])))))

     experimental? (preferences/use-experimental?)

     in-trash?
     (match (nsql/analyze-simple query)
       {:in folder}
       (= (str/lower-case folder) (-> me me/trash-folder :name str/lower-case))
       _
       false)]

    [pf/c-toolbar props
     [pf/c-toolbar-content
      [pf/c-toolbar-group
       [pf/c-toolbar-item {:class :pf-u-ml-sm}
        [pf/c-checkbox-with-highlight
         {:id (uix/memo #(gensym) [])
          :is-checked has-selected?
          :on-change
          (fn [_]
            (if has-selected?
              (sel/clear!)
              (sel/set! (map :id fragments))))}]]]

      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon :reload
         :on-click #(ps/pub! [:search/execute true])
         :tooltip "Reload"}]

       (when-not in-trash?
         [w/c-toolbar-button
          {:icon :plus
           :on-click
           #(go
              (u/when-ok [_ (<! (fragment.attachments/!create-fragment-ui me {:folder (fragment-folder/query->folder-id (:folders me) query)}))]
                (ps/pub! [:search/execute false])))
           :tooltip "Create fragment"}])]

      (when in-trash?
        [w/c-toolbar-button
         {:icon :delete-empty-outline
          :tooltip "Empty Trash"
          :is-disabled (= 0 (count fragments))
          :on-click
          #(go
             (when (<! (fragment-folder/!empty-trash))
               (ps/pub! [:me/load])
               (ps/pub! [:search/execute false])))}])

      (when has-selected?
        [:<>
         [pf/c-toolbar-group {:variant :icon-button-group}

          (when-not in-trash?
            [w/c-toolbar-button
             {:icon :tag-multiple-outline
              :is-disabled (or (not (all :writableHint)) (any :in-trash))
              :on-click (handler fragment-label/!edit-labels)
              :tooltip "Labels"}])

          [w/c-toolbar-button
           {:icon :folder-move-outline
            :is-disabled (or (any :promotedHint) (not (all :writableHint)))
            :on-click (handler fragment-folder/!move)
            :tooltip "Move to another folder"}]

          (when-not in-trash?
            [w/c-toolbar-button
             {:icon :send-outline
              :is-disabled (any :promotedHint)
              :on-click (handler share-send/!send)
              :tooltip "Send to another user"}])

          (when (and (not in-trash?) experimental?)
            [w/c-toolbar-button
             {:icon :folder-zip-outline
              :experimental? true
              :is-disabled (zip/no-downloadable-files? selected-fragments)
              :on-click (handler wz/!download)
              :tooltip "Download as zip"}])

          (when-not in-trash?
            (let [{:keys [status allowed]} (get-in me [:caps :datev])]
              (when (= :connected status)
                [w/c-toolbar-button
                 {:icon :cloud-arrow-up-outline
                  :is-disabled (or (not allowed) (not (all :promotedHint)))
                  :on-click (handler ncr.widgets.datev/schedule-upload!)
                  :tooltip "Upload to DATEV"}])))

          (when-not in-trash?
            [w/c-toolbar-button
             {:icon :pencil-outline
              :is-disabled (or (not (all :writableHint)) (not (some? (u/singleton selected))) (any :in-trash))
              :on-click (handler fragment-common/!fragment-edit)
              :tooltip "Edit fragment"}])]

         (when (and (not in-trash?) experimental?)
           [w/c-toolbar-button
            {:icon :cash-sync
             :experimental? true
             :is-disabled (not (all :writableHint))
             :on-click (handler props.money/!mass-set-netto)
             :tooltip "Mass-update netto property"}])

         (when-not in-trash?
           [pf/c-toolbar-group {:variant :icon-button-group}
            [w/c-toolbar-button
             {:icon :account-multiple-outline
              :is-disabled (not (and (all :ownerWritableHint) (all :promotedHint)))
              :on-click
              (handler fragment-access/!permissions)
              :tooltip "Manage permissions"}]

            [wf/c-promote
             (or (any :promotedHint) (not (all :writableHint)) (any :in-trash))
             (handler fragment-access/!promote)
             (handler fragment-access/!quick-promote)]])

         (when-not in-trash?
           (cond
             (all :revoked)
             [w/c-toolbar-button
              {:icon :rocket-launch-outline
               :on-click (handler fragment-common/!quick-unrevoke)
               :tooltip "Return to Accepted"}]

             (and (all :promotedHint) (not (any :revoked)))
             [w/c-toolbar-button
              {:icon :trash-can-outline
               :on-click (handler fragment-common/!quick-revoke)
               :tooltip "Revoke fragment"}]

             :else
             [w/c-toolbar-button
              {:icon :trash-can-outline
               :is-disabled (or (any :in-trash) (any :promotedHint))
               :on-click (handler fragment-folder/!move-to-trash)
               :tooltip "Delete fragment (move to Trash folder)"}]))])

      [pf/c-toolbar-group
       {:variant :icon-button-group
        :alignment {:default :align-right}}
       (let [blurred? (pspec/use-search-blur-sensitive)]
         [w/c-toolbar-button
          {:icon (if @blurred? :eye-lock-outline :eye-outline)
           :on-click #(swap! blurred? not)
           :tooltip "Blur sensitive values"}])

       (let
         [group-by (pspec/use-search-group-by)
          profile-key (get props :profile-key)
          {:keys [mode no-date-last?] :or {no-date-last? true}}
          (or
            (get @group-by profile-key)
            (get @group-by :default))]

         ^{:key mode}
         [pf/c-tooltip {:content [:span "Preferences"]}
          [pf/c-toolbar-item
           [pf/c-dropdown-menu {:toggle {:icon [w/c-toolbar-icon {:icon :apps}]}}
            [pf/c-menu {:is-plain true}
             [pf/c-menu-content
              [pf/c-menu-group {:label "Group by"}
               (into [pf/c-menu-list]
                 (for [[k title] [[:none "None"] [:date "Date"]]]
                   [pf/c-menu-item
                    {:is-selected (= k mode)
                     :on-click
                     #(swap! group-by assoc-in [profile-key :mode] k)}
                    title]))]
              (when (= :date mode)
                [:<>
                 [pf/c-divider]
                 [pf/c-menu-group {:label "Date"}
                  (into [pf/c-menu-list]
                    (for [[v title] [[false "first"] [true "last"]]]
                      [pf/c-menu-item
                       {:is-selected (= v no-date-last?)
                        :on-click
                        #(swap! group-by assoc-in [profile-key :no-date-last?] v)}
                       (str "'No Date' fragments " title)]))]])]]]]])]]]))